import { InteractionTwoTone } from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App, Popconfirm } from 'antd';
import { useState } from 'react';
import { returnStatus } from '../../../api';
import { components } from '../../../api/schema';
import { DataTableActionProps } from '../../../shared/dataTable/DataTable';

export const ReturnStatus = ({ record }: DataTableActionProps<components['schemas']['InTransitCondensed']>) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const mutation = useMutation({
    mutationFn: (id: string) => returnStatus(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getShipmentInTransitList'] });
      message.success('Status cambiado correctamente');
    },
    onError: () => {
      message.error('Ocurrio un error, vuelve a intentarlo más tarde');
    },
  });

  return (
    <Popconfirm
      title="Cambiar status"
      description={`Deseas regresar el servicio al status de En Piso?`}
      open={open}
      onConfirm={() => mutation.mutate(record.id)}
      okButtonProps={{ loading: mutation.isLoading }}
      onCancel={() => setOpen(false)}
      cancelText="Cancelar"
      okText="Cambiar status"
    >
      <InteractionTwoTone twoToneColor={'#cf1322'} onClick={() => setOpen(true)} />
    </Popconfirm>
  );
};
